const focusNewCell = (e, focusedRow, id, tableId) => {
  e.preventDefault();
  const nodes = document.querySelectorAll(`[data-row="${focusedRow}"][data-col="${id}"][data-parent="${tableId}"]`);
  if (nodes[0]) {
    const focusableElement = nodes[0].querySelectorAll('[tabIndex]')[0] || nodes[0].querySelectorAll('label')[0];
    if (focusableElement) {
      focusableElement.focus();
    } else {
      nodes[0].focus();
    }
  }
};
const click = (e, columnId) => {
  if (columnId !== 'selection') {
    e.target.click();
  }
};
const isEditableFieldTarget = e => e.target.type === 'textarea' || e.target.type === 'text' || e.target.type === 'number';
export const onKeyDownHandler = (focused, tableId, rtState) => e => {
  let focusedColumn = focused.column,
    focusedRow = focused.row;
  const columns = rtState.allVisibleColumns,
    endRow = rtState.endRow;
  switch (e.key) {
    case 'ArrowLeft':
      {
        if (isEditableFieldTarget(e)) {
          return;
        }
        if (focusedColumn > 0) {
          focusedColumn -= 1;
        }
        break;
      }
    case 'ArrowRight':
      {
        if (isEditableFieldTarget(e)) {
          return;
        }
        if (focusedColumn < columns.length - 1) {
          focusedColumn += 1;
        }
        break;
      }
    case 'ArrowUp':
      {
        if (isEditableFieldTarget(e)) {
          return;
        }
        if (focusedRow > 0) {
          focusedRow -= 1;
        }
        break;
      }
    case 'ArrowDown':
      {
        if (isEditableFieldTarget(e)) {
          return;
        }
        if (focusedRow < endRow) {
          focusedRow += 1;
        }
        break;
      }
    case 'Home':
      {
        if (isEditableFieldTarget(e)) {
          return;
        }
        if (e.ctrlKey) {
          if (focusedRow !== 0) {
            focusedRow = 0;
          }
        }
        if (focusedColumn !== 0) {
          focusedColumn = 0;
        }
        break;
      }
    case 'End':
      {
        if (isEditableFieldTarget(e)) {
          return;
        }
        if (e.ctrlKey) {
          if (focusedRow !== endRow) {
            focusedRow = endRow;
          }
        }
        if (focusedColumn !== columns.length - 1) {
          focusedColumn = columns.length - 1;
        }
        break;
      }
    case 'PageUp':
      {
        if (focusedRow !== 0) {
          focusedRow = 0;
        }
        break;
      }
    case 'PageDown':
      {
        if (focusedRow !== endRow) {
          focusedRow = endRow;
        }
        break;
      }
    case 'Enter':
      {
        if (e.altKey) {
          return;
        }
        click(e, columns[focusedColumn].id);
        break;
      }
    default:
      return;
  }
  focusNewCell(e, focusedRow, columns[focusedColumn].id, tableId);
};